import { ChevronUpDown, EkoreLogo, LogOut, Refresh } from '../icons'

interface Props {
  siteName: string
  siteKind?: string
  liveTime: string
  onSiteClick?: () => void
  onRefresh?: () => void
  refreshing?: boolean
  user?: string | null
  onLogout?: () => void
}

export function AppHeader({
  siteName,
  siteKind = 'Ristorante',
  liveTime,
  onSiteClick,
  onRefresh,
  refreshing,
  user,
  onLogout,
}: Props) {
  return (
    <header className="app-header">
      <div className="app-header__inner">
        <EkoreLogo variant="color" height={32} />
        <div className="header-sep" />
        <button
          className="site-pill"
          type="button"
          aria-label={`Panoramica ${siteName}`}
          onClick={onSiteClick}
        >
          <span className="site-pill__mark">OWW</span>
          <span>{siteName}</span>
          <span className="site-pill__sub">· {siteKind}</span>
          <span className="site-pill__chev"><ChevronUpDown /></span>
        </button>
        <div className="header-spacer" />
        {onRefresh && (
          <button
            className="header-refresh"
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            aria-label="Aggiorna ora"
            title="Aggiorna ora"
            data-spinning={refreshing}
          >
            <Refresh />
          </button>
        )}
        <div className="header-meta" title="Ultimo aggiornamento">
          <span className="dot"></span>
          <span>LIVE · {liveTime}</span>
        </div>
        {user && onLogout && (
          <button
            className="header-logout"
            type="button"
            onClick={onLogout}
            aria-label={`Esci (${user})`}
            title={`Esci (${user})`}
          >
            <LogOut />
            <span>Esci</span>
          </button>
        )}
      </div>
    </header>
  )
}
